import {Text} from './text';

export class Menu {
  menuLabel: Text[] = [];
  menuLabelPd: Text[] = [];
  start: number = 0;
  end: number = 0;
  constructor(data?: Menu) {
    this.menuLabel = data?.menuLabel ?? [];
    this.menuLabelPd = data?.menuLabelPd ?? [];
    this.start = data?.start ?? 0;
    this.end = data?.end ?? 0;
  }
}

export const HeaderMenu: Menu[] = [
  {
    menuLabel: [new Text({text: ['О нас', 'About']})],
    menuLabelPd: [new Text({text: ['О нас', 'About'], fontFamily: 'pd', fontStyle: 'italic'})],
    start: 0,
    end: 0,
  },
  {
    menuLabel: [{text: ['Направления', 'Destinations']}],
    menuLabelPd: [new Text({text: ['Направления', 'Destinations'], fontFamily: 'pd', fontStyle: 'italic'})],
    start: 1,
    end: 6,
  },
  {
    menuLabel: [{text: ['Услуги', 'Services']}],
    menuLabelPd: [new Text({text: ['Услуги', 'Services'], fontFamily: 'pd', fontStyle: 'italic'})],
    start: 7,
    end: 7,
  },
  {
    menuLabel: [{text: ['Приключения', 'Adventures']}],
    menuLabelPd: [new Text({text: ['Приключения', 'Adventures'], fontFamily: 'pd', fontStyle: 'italic'})],
    start: 8,
    end: 8,
  },
  {
    menuLabel: [{text: ['VIP in Airports', 'VIP in Airports']}],
    menuLabelPd: [new Text({text: ['VIP in Airports', 'VIP in Airports'], fontFamily: 'pd', fontStyle: 'italic'})],
    start: 9,
    end: 9,
  },
];
